import { Box } from "@mui/material";
import { MouseEvent } from "react";

type StudioResizeHandleProps = {
    side: "left" | "right";
    onMouseDown: (event: MouseEvent<HTMLDivElement>) => void;
};

const StudioResizeHandle = ({ side, onMouseDown }: StudioResizeHandleProps) => (
    <Box
        className={`platform-studio__resize-handle platform-studio__resize-handle--${side}`}
        onMouseDown={onMouseDown}
    />
);

export default StudioResizeHandle;
